export class AppSettings {
    public static API_URL='https://api.goal.ge/api/';
    // public static API_URL='https://api.golazoo.com/api/';
    // public static API_URL='http://apigoal.rentslist.ge/api/';
    public static STORAGE_URL='//storage.goal.ge/';
    public static FRONTEND_URL='//goal.ge/';
    // public static API_URL='http://127.0.0.1:6666/api/';
 }
